<template>
  <section class="row">
    <main>
      <div class="map">
        <div class="map-options-top">
          <a @click="setMapCenterTo(getGeoCenter(markers.museums.data))">
            <img class="icon" src="../assets/icons/refresh.svg" alt="">
            <span>Karte zurücksetzen</span>
          </a>
          <a @click="setMapCenterTo(markers.fixed.here.pos, 15)">
            <img class="icon" src="../assets/icons/Ic_my_location_48px.svg" alt="">
            <span>Ihr Standort</span>
          </a>
          <a @click="setMapCenterTo(markers.fixed.digicult.pos, 15)">
            <img class="icon" src="../assets/icons/digicult_square_colorless.svg" alt="">
            <span>digiCULT Büro</span>
          </a>
        </div>
        <l-map v-if="markers.museums.data"
               id="digicult-member-map"
               :zoom="mapOptions.zoom"
               :center="center"
               ref="membermap"
        >
          <l-control-layers position="topright"/>
          <l-tile-layer v-for="(tileProvider, index) in tileProviders"
                        :key="index"
                        layerType="base" :name="tileProvider.name" :visible="tileProvider.visible"
                        :url="tileProvider.url" :attribution="tileProvider.attribution"
          />
          <l-geo-json v-for="(association, index) in geojson"
                      v-if="association.show"
                      :key="index"
                      :geojson="association.data"
                      :options="association.options"
          />
          <l-marker-cluster :options="markerCluster.options">
            <l-marker v-for="museum in markers.museums.data"
                      :icon="markers.museums.icon"
                      :key="museum.id"
                      :lat-lng="makeLatLng(museum.pos)"
                      @click="fetchMuseum(museum.id)"
            >
              <l-popup :lat-lng="makeLatLng(museum.pos)">
                <h3 class="popup-title">{{museum.name}}</h3>
                <div v-if="selectedMuseum && selectedMuseum.id === museum.id" class="popup">
                  <address v-if="getSelectedMuseumAddress()">
                    {{getSelectedMuseumAddress().street}} <br>
                    {{getSelectedMuseumAddress().zip}} {{getSelectedMuseumAddress().place}}
                  </address>
                  <figure v-if="getSelectedMuseumImage()">
                    <img :src="getSelectedMuseumImage().link"
                         :alt="museum.name"
                         style="max-width: 100%"
                    />
                  </figure>
                </div>
              </l-popup>
            </l-marker>
          </l-marker-cluster>
          <l-marker :lat-lng="markers.fixed.digicult.pos">
            <l-popup :content="markers.fixed.digicult.label" :lat-lng="markers.fixed.digicult.pos"></l-popup>
          </l-marker>
          <l-marker :lat-lng="markers.fixed.here.pos">
            <l-popup :content="markers.fixed.here.label" :lat-lng="markers.fixed.here.pos"></l-popup>
          </l-marker>
        </l-map>
      </div>
      <div class="map-options">
        <toggle-button v-for="(association, index) in geojson"
                       :key="index"
                       :association="association"
        />
      </div>
    </main>
    <aside>
      <div class="columns">
        <div class="column" v-for="(website, index) in websites" :key="index">
          <teaser-button :image="website.img" :url="website.url"/>
        </div>
      </div>
      <div class="logo">
        <img src="../assets/logo/digiCULT_logo_website_colorless.svg" alt="">
      </div>
    </aside>
  </section>
</template>

<script>
    import {LMap, LTileLayer, LMarker, LPopup, LGeoJson, LControlLayers} from 'vue2-leaflet';
    import LMarkerCluster from 'vue2-leaflet-markercluster';
    import L from 'leaflet';
    import geolib from 'geolib';

    import {mvth, mvshhh, mvsaar, lvr} from "./configs/geojson";
    import {websites} from "./configs/websites"
    import {markerCluster} from "./configs/marker_cluster";
    import {tileProviders} from "./configs/tile_providers";

    import {EventBus} from "../event-bus";

    import TeaserButton from './partials/TeaserButton';
    import ToggleButton from './partials/ToggleButton';

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });

    export default {
        name: 'MemberMap',
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LGeoJson,
            LMarkerCluster,
            LControlLayers,
            TeaserButton,
            ToggleButton
        },
        created() {
            fetch(this.markers.museums.source)
                .then(stream => stream.json())
                .then(data => this.markers.museums.data = data.Actor)
                .catch(error => {
                    console.log('use fallback');
                    fetch(this.markers.museums.fallback)
                        .then(stream => stream.json())
                        .then(data => this.markers.museums.data = data.Actor)
                });

            EventBus.$on('resetApplication', () => this.resetComponent());
        },
        computed: {
            center: {
                get() {
                    return this.markers.museums.data ?
                        this.getGeoCenter(this.markers.museums.data) :
                        [0, 0]
                }
            }
        },
        data() {
            return {
                tileProviders,
                mapOptions: {
                    zoom: 6,
                    isCenterd: false
                },
                markerCluster,
                markers: {
                    museums: {
                        source: 'http://portal-dev.digicult-verbund.de/data.php',
                        fallback: 'http://portal-dev.digicult-verbund.de/cache/data.json',
                        data: null,
                        icon: L.icon({
                            iconUrl: 'http://saarland-alt.digicult-museen.net/home/map/images/museum.png',
                            iconSize: [40, 40],
                            iconAnchor: [20, 20],
                            popupAnchor: [0, -20]
                        })
                    },
                    fixed: {
                        digicult: {
                            pos: [54.339798, 10.140671],
                            label: 'digiCULT Verbund eG'
                        },
                        here: {
                            pos: [53.6610169, 9.79605090],
                            label: 'Ihr Standort'
                        }
                    }
                },
                geojson: {mvth, mvsaar, mvshhh, lvr},
                websites,
                selectedMuseum: null
            }
        },
        methods: {
            resetComponent() {
                this.setMapCenterTo(this.getGeoCenter(this.markers.museums.data))
            },
            resetTimer() {
                EventBus.$emit('resetCountdown');
            },
            setMapCenterTo(latLng, zoom = 6) {
                if (latLng === this.getGeoCenter(this.markers.museums.data))
                    this.mapOptions.isCenterd = true;
                this.$refs.membermap.mapObject.flyTo(latLng, zoom, {
                    animate: true,
                    pan: {
                        duration: 2,
                    }
                });
            },
            makeLatLng(pos) {
                let coord = pos.split(' ');
                return [coord[1], coord[0]]
            },
            getGeoCenter(museums) {
                let coords = [];
                museums.forEach(function (museum) {
                    let pos = museum.pos.split(' ');
                    let latlng = {
                        latitude: Number(pos[1]),
                        longitude: Number(pos[0])
                    };
                    if (latlng.latitude !== 0 && latlng.longitude !== 0)
                        coords.push(latlng);
                });
                return [Number(geolib.getCenter(coords).latitude), Number(geolib.getCenter(coords).longitude)];
            },
            fetchMuseum(id) {
                this.selectedMuseum = null;
                fetch(`${this.markers.museums.source}?id=${id}`)
                    .then(stream => stream.json())
                    .then(data => this.selectedMuseum = data.Actor);
            },
            getSelectedMuseumAddress() {
                let address = this.selectedMuseum.address.filter((addr) => {
                    return addr.type === 'visitor' ? addr : false
                });
                return address[0];
            },
            getSelectedMuseumImage() {
                if (this.selectedMuseum.resource) {
                    let resource = this.selectedMuseum.resource[0].resourceRepresentation.filter(image => {
                        return image.type === 'thumbnail' ? image : null
                    });
                    return resource[0]
                }
                return null;
            }
        }
    }
</script>

<style lang="scss">
  @import "../../node_modules/leaflet/dist/leaflet.css";
  @import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
  @import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";

  .leaflet-control-layers-base label {
    padding: 1em;
  }

  .popup {
    figure {
      margin: 0;
      padding: .5em 0 0 0;
    }
  }
</style>

<style lang="scss" scoped>
  i.icon {
    font-size: 4em;
  }

  img.icon {
    height: 4em;
    width: auto;
  }

  section {
    display: grid;
    grid-template-columns: 1fr .6218fr;
    grid-gap: 15px;
    height: calc(100vh - 82px);
    padding: 15px;

    main {
      margin-top: 0;
      height: calc(100vh - 82px);

      .map {
        display: grid;
        grid-template-rows: repeat(7, 1fr);
        grid-gap: 15px;
        height: 100%;
      }

      #digicult-member-map {
        border-radius: 15px;
        grid-row: 1 / 7;
      }

      .map-options-top {
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        a {
          padding: .25em 1em .75em;
          color: #fff;
          overflow: hidden;
          background: linear-gradient(
              to bottom,
              rgba(255, 255, 255, .5) 0%,
              rgba(255, 255, 255, .3) 20%,
              rgba(255, 255, 255, .1) 21%,
              rgba(255, 255, 255, 0) 100%
          );
          box-shadow: inset 0 0 20px 1px #333333;
          border-radius: 15px;

          &:hover, &:active, &:focus {
            background: linear-gradient(
                to bottom,
                rgba(100, 100, 100, .7) 0%,
                rgba(100, 100, 100, .5) 20%,
                rgba(100, 100, 100, .3) 21%,
                rgba(100, 100, 100, 0) 100%
            );
          }

          display: flex;
          flex-direction: column;
          justify-content: center;

          span {
            text-align: center;
            font-size: 12px;
            width: 150px;
          }
        }

      }

      .map-options {
        margin-top: 15px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 15px;
      }
    }

    aside {
      .columns {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 15px;
        height: calc(100vh - 82px);

        .column {
          overflow: hidden;
          background: linear-gradient(
              to bottom,
              rgba(255, 255, 255, .5) 0%,
              rgba(255, 255, 255, .3) 20%,
              rgba(255, 255, 255, .1) 21%,
              rgba(255, 255, 255, 0) 100%
          );
          box-shadow: inset 0 0 20px 1px #333333;
          border-radius: 15px;

          &:hover, &:active, &:focus {
            background: linear-gradient(
                to bottom,
                rgba(100, 100, 100, .7) 0%,
                rgba(100, 100, 100, .5) 20%,
                rgba(100, 100, 100, .3) 21%,
                rgba(100, 100, 100, 0) 100%
            );
          }

          display: flex;
        }
      }
    }
  }

  .logo {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    img {
      height: 35px;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue